import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/TransportSimulation.requests'
import {
    ProductTypeSimulation,
} from '../Simulation/simulation.types'

const useGetProductTypes = () => {
    const {
        data,
    } = useRequest<ProductTypeSimulation[]>({
        key: RequestKeys.getProductTypesTransportSimulation,
        requestFunc: RequestFn.getEntity(config.productTypesAll),
    })

    return data
}

export default useGetProductTypes
